module.exports = __webpack_public_path__ + "images/Zhiwei.jpg?v=a0ec87f2897f49bce102493f5066f922";